import React, { useState, useEffect } from "react";
import "./ServicesList.css";
import { Container } from 'react-bootstrap'
import {ChildServiceDetails, Header ,ServiceList } from "../../Features/ServicesList"


const ServicesList = ({ errorNotFound, pageData, url }) => {

    const [data, setData] = useState([]);
    const [showHeader, setShowHeader] = useState(true);

        
         useEffect(()=>{
          if(pageData){
            setData(pageData);
          }

         },[pageData])  

    return (
        <Container className='PackagesCategoriesList-page-container PackagesList-page-container'> 
            {showHeader && <Header pageData={data} />}
            <ServiceList url={url}  errorNotFound={errorNotFound} setShowHeader={setShowHeader}/>  
        </Container>
    );
}

export default ServicesList;
